module.exports = __webpack_public_path__ + "img/beans-4.8684aa50.png";